import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
//import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { MessageService } from 'primeng/api';
import { PrimeNGConfig } from 'primeng/api';
import { ApiService } from '../../../services/api.service';
import { FileUpload } from 'primeng/fileupload';
import { environment } from '../../../../environments/environment';
import { EditorComponent } from '@tinymce/tinymce-angular';
import { init } from '../../editorconfig';
import { UploadService } from '../../../services/upload/upload.service';
import { DmsFile } from '../../../modal/upload/model/upload.model';
import { getTenderOpeningSheetTemplate } from '../../../pre-ready-tepmlate';

@Component({
  selector: 'app-final-offer',
  standalone: false,
  templateUrl: './final-offer.component.html',
  styleUrl: './final-offer.component.scss'
})
export class FinalOfferComponent implements OnInit {
  @Output() routeConfig: EventEmitter<any> = new EventEmitter();
  @Input() id: any
  @Input() getUrl: string;
  @Input() postUrl: string;
  @Output() generatePDFEmitter = new EventEmitter<any>();
  @ViewChild('fileUpload') fileUpload!: FileUpload;
  @Output() stepCompleted = new EventEmitter<void>();
  commentForm: FormGroup;
  @Input() step: any;
  @Output() IRA: EventEmitter<any> = new EventEmitter();
  @Input() isEditable: boolean = false;
  @Input() stepDetails: any;
  apiUrl = environment.APIUrl;
  isEditorDisabled: boolean = false;
  init: EditorComponent['init'] = init;
  rfpdata: any;
  payload: {
    proposal_id: any;
    proposal_name: any;
  };
  uploadedFileName: string = '';
  file: File;
  selectedFinalOfferFile: File | null = null;
  finalOfferFilePath: string | null = null;
  @Input() schemeType: string;
  userID: any;
  resId:any;
  allDmsFiles: any[]=[];
  constructor(private fb: FormBuilder, private config: PrimeNGConfig, 
    private messageService: MessageService, private api: ApiService, 
    private uploadService: UploadService, private route: ActivatedRoute) {
          const role = sessionStorage.getItem('user_role_id');
    this.userID = role
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params: any) => {
      const proposalId = params['id'];
      // const proposalStep = params['step'];
      const proposalName = params['name'];
      this.payload = {
        proposal_id: proposalId,
        // proposal_step:proposalStep,
        proposal_name: proposalName
      }
      //console.log(this.payload);
    });
    this.commentForm = this.fb.group({
      final_offer: ['', Validators.required],
      installation_date: [''],
      delivery_date: [''],
      offer: [''],
      final_cost: [''],
      tec_table: [''],
    });
    this.getRfpDetails();
  }

  goToNextStep() {
    this.stepCompleted.emit();
  }
  ngAfterViewInit() {
    setTimeout(() => {

      this.commentForm.enable();
      if (this.stepDetails?.can_edit) {
      } else {
        // this.commentForm.disable();
      }
      this.rebuildEditor()
    }, 3000);
  }
      editorReady = false;
  rebuildEditor() {
  this.editorReady = false; // destroy
  setTimeout(() => {
    this.init = this.getTinyInit(); // refresh config
    this.editorReady = true; // recreate editor
  }, 0);
}
getTinyInit(): EditorComponent['init'] {
  return {
    readonly: this.isEditorDisabled
  };
}
  getRfpDetails() {
  let url;
  if (this.schemeType == 'makeI' || this.schemeType == 'makeII' || this.schemeType == 'makeIII') {
    url = `/make1/final-offer/`
  } else if (this.schemeType == 'idex') {
    url = `/idex/final-offer/`
  }  else if(this.schemeType == 'rev') {
    url = `/revenue/final-offer/`
  }
  else {
    url = `/tdf/final-offer/`
  }
  this.api.getAPI(url + `?proposal_step=${this.step.id}&proposal_step__proposal=${this.payload.proposal_id}`)
    .subscribe((res: any) => {
      if (!res) return;
      // ✅ Handle both array or single object response
      const data = Array.isArray(res) ? res[0] : res;
      this.rfpdata = data;
      console.log('this is final offer', this.rfpdata,);
        const dmsFiles: DmsFile[] = this.rfpdata.dms_files;
          this.allDmsFiles = dmsFiles;
      this.commentForm.patchValue({
        final_offer: data?.justification || '',
        installation_date: data?.installation_date || '',
        delivery_date: data?.delivery_date || '',
        offer: data?.offer || '',
        final_cost: data?.final_cost || '',
        tec_table: data?.tec_table || getTenderOpeningSheetTemplate('TEC table',this.stepDetails),
      });
      // ✅ Set existing file path safely
      this.finalOfferFilePath = data?.offer || null;
      this.selectedFinalOfferFile = null;
      console.log('Final Offer File Path:', this.finalOfferFilePath);
    });
}





  onSubmit(): void {
    // if (this.commentForm.valid) {
    let vendor_id = sessionStorage.getItem('final_vendor')
    const formData = new FormData();
    formData.append('proposal_step', this.id);
   
     formData.append('justification', this.commentForm.get('final_offer').value);
     formData.append('installation_date', this.commentForm.get('installation_date').value);
     formData.append('delivery_date', this.commentForm.get('delivery_date').value);
     formData.append('offer', this.commentForm.get('offer').value);
      formData.append('final_cost', this.commentForm.get('final_cost').value);
        formData.append('tec_table', this.commentForm.get('tec_table').value);
    if (this.file) {
      formData.append('offer', this.file);
    }
    let url;
    if (this.schemeType == 'makeI' || this.schemeType == 'makeII' || this.schemeType == 'makeIII') {
      url = `/make1/final-offer/`
    }  else if(this.schemeType == 'idex') {
      url = `/idex/final-offer/`
    } else if(this.schemeType == 'rev') {
      url = `/revenue/final-offer/`
    }
    else {
      url = `/tdf/final-offer/`
    }

    if (this.rfpdata?.id) {
      this.api.putAPI(url + this.rfpdata?.id + '/', formData).subscribe((res: any) => {
        this.finalOfferFilePath = res?.file || null;
        this.selectedFinalOfferFile = null;

        this.getRfpDetails();
        this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message || 'Data updated successfully' });
      });
    } else {
      this.api.postAPI(url, formData).subscribe((res: any) => {
        this.selectedFinalOfferFile = null;
        this.finalOfferFilePath = res?.file || null;
        this.getRfpDetails();
        this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message || 'Data  uploaded successfully' });
        // this.stepCompleted.emit(); 
      });
    }

  }

  generatePDF() {
    const payload = {
      url: '/revenue/need/version-control/',
      data: [
        { key: "Proposal Name", value: this.payload.proposal_name },
        { key: "Final Offer", value: this.commentForm.get('final_offer')?.value },
      ]
    }
    this.generatePDFEmitter.emit(payload);
  }
  extractFileName(path: string): string {
    return path.split('/').pop() || path;
  }

  clearUpload() {
    this.selectedFinalOfferFile = null;
  }

}



